"use client";

import clsx from "clsx";

import { useInNativeApp } from "../../../_hooks/use-in-native-app";

/**
 * アプリ内かどうかは描画後にしか判定できないので、余白の切り替えだけをここに閉じ込め、本文は children でサーバから受け取る。
 */
export function NativeAppAwareContainer({
  className,
  children,
}: {
  className: string;
  children: React.ReactNode;
}) {
  const isInNativeApp = useInNativeApp();
  return (
    <div className={clsx(className, isInNativeApp ? "px-[30px]" : "pr-[50px]")}>
      {children}
    </div>
  );
}
